// extracted by mini-css-extract-plugin
export default {"parent":"posts_parent__sk4Wq","line":"posts_line__YUIQi","boxes":"posts_boxes__S8ym6"};